import React, {useEffect, useState} from 'react';
import {LOCAL_STORAGE_USER_LOGIN_INFO} from "@app/constants/Common";
import {SavedListTabOptions} from "@pages/savedlist/common/Constant";
import SavedList from "@pages/savedlist/SavedList";
import QuickSearchSavedList from "@pages/savedlist/QuickSearchSavedList";
import {toast} from "react-toastify";
import MergeCandidateGroupModal from "@pages/savedlist/MergeCandidateGroupModal";
import {optionsToArray, optionsToString} from "@app/utils/CommonUtils";
import {requestCandidateGroups} from "@app/services/CandidateGroupService";
import {callApiSearchSavedList} from "@pages/savedlist/common/Services";
import AddCandidateIntoGroupModal from "@pages/savedlist/AddCandidateIntoGroupModal";
import CreateCandidateGroupModal from "@pages/savedlist/CreateCandidateGroupModal";
import MailTemplateList from "@pages/email/template/list/MailTemplateList";
import {MailTempType} from "@pages/email/common/Constant";

const InviteJobTemplateListManager = (props) => {
    const [currentTab, setCurrentTab] = useState('industry-tab');
    const [userLoginInfo, setUserLoginInfo] = useState({});
    const [showMergeGroupModal, setShowMergeGroupModal] = useState(false);
    const [quickSearchInput, setQuickSearchInput] = useState({});
    const [totalCount, setTotalCount] = useState(0);
    const [tabTotals, setTabTotals] = useState({});
    const [showAddCandidateIntoGroupModal, setShowAddCandidateIntoGroupModal] = useState(false);

    const searchCandidateGroups = async (searchInputConditions) => {
        let params = {}
        if (searchInputConditions) {
            params.search_conditions = {...searchInputConditions}
            params.search_conditions.tabs = optionsToArray(searchInputConditions.select_tabs)
        }

        await callApiSearchSavedList(params, (res) => {
            const resContent = res.content
            setTotalCount(resContent.total_count)
            const groupTabTotals = {}
            resContent.tab_totals.forEach(item => {
                groupTabTotals[item.tab] = item.total
            })

            setTabTotals({...groupTabTotals})
        });
    }

    useEffect(() => {
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            setUserLoginInfo(JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)))
        }
    }, [])

    useEffect(async () => {
        await searchCandidateGroups(quickSearchInput)
    }, [quickSearchInput])

    const onTabClicked = (tabId) => {
        setCurrentTab(tabId);
    };

    const activeTab = (tab) => {
        if (currentTab === tab) {
            return 'active'
        }
        return ''
    }

    const getTabTitle = (tab) => {
        const total = tabTotals[tab.id] ? tabTotals[tab.id] : 0
        return `${tab.title} (${total})`
    }

    return (
        <>
            <div className='card card-default'>
                <div className='card-header'>
                    <h3 className='card-title text-bold'>Email template mời Job</h3>
                    <div className='card-tools'>
                        {/*<button type='button' className='btn btn-primary mr-2 ml-3'*/}
                        {/*        onClick={() => {*/}
                        {/*            setShowAddCandidateIntoGroupModal(true)*/}
                        {/*        }}>Tạo list mới*/}
                        {/*</button>*/}
                        {/*<button type={"button"}*/}
                        {/*   className='btn btn-success mr-3'*/}
                        {/*   onClick={() => {*/}
                        {/*       setShowMergeGroupModal(true)*/}
                        {/*   }}>*/}
                        {/*    Tạo list từ list*/}
                        {/*</button>*/}
                    </div>
                </div>
                <div className='card-body p-0'>
                    <ul className='nav nav-tabs' role='tablist'>
                        <li className='nav-item'>
                            <a className={`nav-link text-bold active`} data-toggle='tab' href={"#semi-tem-full-list-tab"}
                               onClick={() => {}}>Temp Semi-Full</a>
                        </li>
                        <li className='nav-item'>
                            <a className={`nav-link text-bold`} data-toggle='tab' href={"#job-info-table-tem-list-tab"}
                               onClick={() => {}}>Bảng job info</a>
                        </li>
                    </ul>
                    <div className='tab-content'>
                        <div id={"semi-tem-full-list-tab"} className={`tab-pane active`}
                             style={{height: '83vh', overflow: 'auto'}}>
                            <MailTemplateList templateType={MailTempType.SEMI_FULL}/>
                        </div>
                        <div id={"job-info-table-tem-list-tab"} className={`tab-pane`}
                             style={{height: '83vh', overflow: 'auto'}}>
                            <MailTemplateList templateType={MailTempType.JOB_TABLE}/>
                        </div>
                    </div>
                </div>
            </div>
            {showMergeGroupModal &&
                <MergeCandidateGroupModal isShow={showMergeGroupModal}
                                          onClose={(isSuccess) => {
                                              setShowMergeGroupModal(false)
                                              if (isSuccess === true) {
                                                  toast.success(`Tạo saved list mới thành công.`);
                                                  searchCandidateGroups(quickSearchInput)
                                              } else if (isSuccess === false) {
                                                  toast.error(`Tạo saved list mới thất bại.`);
                                              }
                                          }}
                />
            }

            <CreateCandidateGroupModal isShow={showAddCandidateIntoGroupModal}
                                       candidates={[]}
                                       allCandidateIds={[]}
                                       onClose={(isSuccess) => {
                                           setShowAddCandidateIntoGroupModal(false)
                                           if (isSuccess === true) {
                                               toast.success(`Tạo saved list mới thành công.`);
                                           } else if (isSuccess === false) {
                                               toast.error(`Tạo saved list mới thất bại.`);
                                           }
                                       }}/>
        </>
    )
}

export default InviteJobTemplateListManager;
